module.exports = __webpack_public_path__ + "static/media/TroubleshootingSplunkEnterprise.0b4aedb6.png";